import "../scss/index.scss";

const { scrollout_init } = require('./lib/ushiya/scrollout_init/');


const { 
    define_svg_element,
    emit_on_all_svg_loaded,
    define_footer_element,
} = require('./lib/ushiya/custom_element');

define_svg_element();   
define_footer_element();

window.splide_instance = null;


const scrollout_custom_handler = (e,so,hidden) =>{
    // e... ビューポートに出現した要素(DOMオブジェクト)
    // so... ScrollOutオブジェクトインスタンス
    // hidden... 要素がビューポート外に出た場合はtrue、それ以外はfalse


    if(hidden){

    } else {
        
        if(e.matches('section.top-most-section')){
            let DOM_navigation_svg=document.querySelector('#navigation01');
        
            if(DOM_navigation_svg){

                DOM_navigation_svg.classList.remove('away-from-top');
            }
        }
    }
}

const {
    init_scrollbar
} = require('./sub/misc/init_scrollbar.js');

const {
    activate_section_apply
} = require('./sub/index/activate_section_apply.js');

const {
    activate_section_contact
} = require('./sub/index/activate_section_contact.js');

window.addEventListener('all_svg_ready',
    (e)=>{
        console.log("all_svg_ready");
        //MicroModal.init();
        scrollout_init({
            special_scrollin:scrollout_custom_handler
        });
        activate_section_apply();
        activate_section_contact();        
    }
);

window.addEventListener('DOMContentLoaded',async (event)=>{
    
    // 後で画像参照も使うのであとで
    //emit_on_all_svg_full_loadedの呼び出しに変更する

    emit_on_all_svg_loaded(
        [
            "extern-svg[data-mountpoint='section_main_visual_sp']",
            "extern-svg[data-mountpoint='section_main_visual_pc']",
            "extern-svg[data-mountpoint='section_overview']",
            "extern-svg[data-mountpoint='section_schedule']",
            "extern-svg[data-mountpoint='section_category']",
            "extern-svg[data-mountpoint='section_participation_fee']",
            "extern-svg[data-mountpoint='section_prize']",
            "extern-svg[data-mountpoint='section_award']",
            "extern-svg[data-mountpoint='section_apply']",
            "extern-svg[data-mountpoint='section_program']",
            "extern-svg[data-mountpoint='section_requirement']",
            "extern-svg[data-mountpoint='section_jury_header']",
            "extern-svg[data-mountpoint='section_jury_part1']",
            "extern-svg[data-mountpoint='section_jury_part3']",
            "extern-svg[data-mountpoint='section_jury_part4']",
            "extern-svg[data-mountpoint='section_jury_part5']",
            "extern-svg[data-mountpoint='section_jury_part6']",
            "extern-svg[data-mountpoint='section_jury_part7']",
            "extern-svg[data-mountpoint='section_contact']",
            "extern-svg[data-mountpoint='section_support_by_header']",
            "extern-svg[data-mountpoint='section_support_by_part1']",
            "extern-svg[data-mountpoint='section_support_by_part2']"
        ]

    );

    init_scrollbar();

});